import { render, staticRenderFns } from "./messageLog.vue?vue&type=template&id=81044700"
import script from "./messageLog.vue?vue&type=script&lang=js"
export * from "./messageLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports